import { jsx as d } from "react/jsx-runtime";
import { useRef as f } from "react";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import g from "../../hooks/useSpacingToken.js";
import { paddingSpacings as m } from "../../utils/style.js";
import '../../index24.css';const h = "_heading_1furn_1", p = "_center-aligned_1furn_11", w = "_with-light-background_1furn_15", B = "_with-bottom-border_1furn_19", T = "_level-one_1furn_23", x = "_level-two_1furn_32", F = "_level-three_1furn_40", k = "_level-four_1furn_49", z = "_level-five_1furn_53", S = "_level-six_1furn_57", A = "_ellipsized_1furn_63", e = {
  heading: h,
  centerAligned: p,
  withLightBackground: w,
  withBottomBorder: B,
  levelOne: T,
  levelTwo: x,
  levelThree: F,
  levelFour: k,
  levelFive: z,
  levelSix: S,
  ellipsized: A
}, N = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
};
function j(r) {
  const {
    className: t,
    level: n = 3,
    children: o,
    ellipsize: i,
    centerAligned: s,
    variant: l = "container",
    spacing: c
  } = r, _ = g({
    spacing: c,
    modes: m
  }), a = `h${n}`, v = f(null);
  return o ? /* @__PURE__ */ d(
    a,
    {
      className: u(
        e.heading,
        i && e.ellipsized,
        N[n],
        s && e.centerAligned,
        l === "form" && _,
        l === "form" && e.withBottomBorder,
        l === "form" && e.withLightBackground,
        t
      ),
      ref: v,
      children: o
    }
  ) : null;
}
export {
  j as default
};
